import i18n from 'i18next'
import languagedetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'

import en from './locales/en'
import nn from './locales/nn'
import nb from './locales/nb'
import pt from './locales/pt'
import es from './locales/es'

const resources = {
  en,
  nn,
  nb,
  pt,
  es
}

declare module 'react-i18next' {
  interface CustomTypeOptions {
    defaultNS: 'nb'
    resources: typeof resources
  }
}

i18n.on('languageChanged', (language) => {
  document.documentElement.setAttribute('lang', language)
})

i18n
  .use(initReactI18next)
  .use(languagedetector)
  .init({
    lng: localStorage.getItem('i18nextLng') || 'nb',
    fallbackLng: 'nb',
    interpolation: {
      escapeValue: false
    },
    react: {
      transSupportBasicHtmlNodes: true
    },
    resources: {
      en: { translation: en },
      nn: { translation: nn },
      nb: { translation: nb },
      pt: { translation: pt },
      es: { translation: es }
    }
  })

export { i18n }
